<template>



    <div class="card card-default shadow">
        <div class="card-body">
            <div class="row">

                <div class="col-md-12">
                    <table class=" table table-bordered table-sm" id="feeTable">
                        <thead class="bg-custom ">
                            <tr>
                                <th>ChallanNo</th>
                                <th>Period</th>
                                <th>Balance</th>
                                <th>Current</th>
                                <th>Total Amount</th>
                                <th>Date Generation</th>
                                <th>Due Date</th>
                                <th>Deposit Status</th>
                                <th>Actions</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in feeChallans">
                                <td>{{item.ChallanNo}} <span v-if="item.DepositDate != 'Unpaid'" class="badge bg-success">Paid</span></td>
                                <td>{{item.Period}}</td>
                                <td class="text-right">{{item.Balance}}</td>
                                <td class="text-right">{{item.Current}}</td>
                                <td class="text-right">{{item.TotalAmount}}</td>
                                <td>{{item.DateGeneration}}</td>
                                <td>{{item.DueDate}}</td>
                                <td>{{item.DepositDate}}</td>
                                <td>
                                    <button type="button" class="btn btn-warning  btn-xs" v-on:click="printChallan(item.FeeChallanID)">Print</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>



            </div>
        </div>
    </div>
</template>
<script>import axios from 'axios';
    export default {
        name: 'fee',
        data() {
            return {

                feeChallans: [],
            }
        },
        created() {
            this.pageLoad();
        },
        updated() {
            $('#feeTable').DataTable();
        },

        methods: {
            pageLoad() {
                var vm = this;
                axios.post('/api/PortalApi/pageLoadFee')
                    .then(function (res) {
                        //var feeChallans = res.data.feeChallans;
                        //if (feeChallans.Balance.length > 3 && feeChallans.Balance.length <= 5) {
                        //  if (feeChallans.Balance.length == 3) {
                        //    feeChallans.Balance = feeChallans.Balance + ',';
                        //  } else if (feeChallans.Balance.length > 5) {

                        //  }
                        //}

                        vm.feeChallans = res.data.feeChallans

                    })
            },
            printChallan(id) {
                window.location.href = "/Portal/FeeChallanPrint?ID=" + id;
            }
        }
    }</script>



// WEBPACK FOOTER //
// src/components/school/fee/fee.vue